export enum CpapOption {
    custom = 'Aangepast',
    standard = 'Standaard',
}
